
<template>
  <!-- 工作日志列表 -->
  <div class="buttonlist">
    <div class="buttonlist-m">
      <el-form :inline="true" :model="filteForm" class="demo-form-inline toolbar" style="padding-bottom: 0px"
        @submit.native.prevent>
        <el-form-item label="日期">
          <el-date-picker
            v-model="filteForm.dayStr"
            :clearable="false"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="请选择日期"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" plain @click="onSubmit">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="warning" plain class="el-icon-plus" @click="showAddForm">新增</el-button>
        </el-form-item>
      </el-form>
      <div v-loading="loading" element-loading-text="拼命加载中......">
        <el-table :data="dataList" style="width: 100%" :row-style="tableRowStyle" :header-cell-style="tableHeaderColor">
          <el-table-column label="日期" width="120" align="center" prop="date" />
          <el-table-column label="填写人" width="120" align="center" prop="userName" />
          <el-table-column label="内容" align="center" prop="workLog" />
          <el-table-column label="操作" width="80" align="center">
            <template slot-scope="scope">
              <el-button type="waring" size="mini" plain @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background @current-change="handleCurrentChange" :current-page="filteForm.pageNum"
          layout="total, prev, pager, next" :total="totalDataNumber" align="center" class="fenye">
        </el-pagination>
      </div>
      <!-- 弹出新增 -->
      <el-dialog title="新增工作日志" :visible.sync="dialogFormVisible" :close-on-click-modal="false"
        :close-on-press-escape="false" class="dangerbuttonxz" @close="closeDialog">
        <el-form ref="form" :model="addForm">
          <el-row>
            <el-form-item label="备注" label-width="80px" prop="remark">
              <el-input v-model.trim="addForm.workLog" type="textarea" :rows="15" class="commonwidth"
                placeholder="请输入备注"></el-input>
            </el-form-item>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click="closeDialog">取 消</el-button>
          <el-button type="primary" @click="submitForm()" :loading="addLoading">确 定</el-button>
        </div>
      </el-dialog>


    </div>
  </div>
</template>
<script>
export default {
  name: "TableCareProject",
  data() {
    return {
      today: "",
      addForm: {
        workLog: "",
      },
      filteForm: {
        dayStr: "",
        oldId: "",
        oldName: "",
        pageNum: 1,
        pageSize: 5
      },
      carePj: [],
      dataList: [],
      currentPage: 1,
      addLoading: false,
      dateValue:'',
      totalDataNumber: 0,
      pageNum: 1,
      formLabelWidth: '120px',
      loading: false,
      dialogShowVisible: false,
      dialogList: [],
      dialogFormVisible: false
    };
  },
  methods: {
    //点击查询
    onSubmit() {
      this.getTableData();
    },
    //删除
    handleEdit(index, row) {
      this.addForm = {
        workLog:row.workLog,
        date:row.date
      };
      this.dialogFormVisible = true;
    },
    showAddForm() {
      this.addForm = {
        workLog:"",
        date:this.getNowDate()
      };
      this.dialogFormVisible = true;
    },
    closeDialog() {
      this.dialogFormVisible = false;
      this.$refs.form.resetFields(); //移除校验结果并重置字段值
    },
    //获取分页的紧急按钮数据  只获取pageSize条数据
    getTableData() {
      let param = {
        dayStr: this.filteForm.dayStr,
        oldId: this.filteForm.oldId,
        pageNum: this.filteForm.pageNum,
        pageSize: this.filteForm.pageSize,
      };
      if (param.oldId == null || param.oldId == '') {
        delete (param.oldId);
      }
      console.log(param);
      this.loading = true;
      this.$postJson("omc/workLog/showList", param).then(
        (res) => {
          console.log(res);
          //判断是否有数据
          if (res.result.length != 0) {
            this.dataList = res.result.list;
            this.totalDataNumber = Number(res.result.total);
            setTimeout(() => {
              this.loading = false;
            }, 100);
          } else {
            this.dataList = [];
            setTimeout(() => {
              this.loading = false;
            }, 1000);
          }
        }
      );
    },
    getNowDate() {
      var date = new Date();
      var seperator1 = "-";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate;
    },
    // 新增弹出框点击确定提交信息
    submitForm() {
      this.addLoading = true;
      let params = new Object();
      params.date = this.addForm.date;
      params.workLog = this.addForm.workLog != "" ? this.addForm.workLog : " "; //为了避免不填请求数据报错  因为就传空格字符串
      this.$postJson(
        "omc/workLog/save",
        params
      ).then(res => {
        if (res.code != "200") {
          this.$message({
            message: res.message,
            type: "error",
          });
        }
      })
      setTimeout(_ => {
        this.addLoading = false;
        this.dialogFormVisible = false;
        this.$refs.form.resetFields(); //移除校验结果并重置字段值
        this.getTableData();
      }, 300)
    },
    // 修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      return "background-color: #ffffff";
    },
    // 修改table header的背景色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 14px;background-color: #d4f5fa;";
      }
    },
    /*
      当前页变化
    */
    handleCurrentChange(val) {
      this.filteForm.pageNum = val;
      this.getTableData(); //刷新套餐列表的数据
    },
  },
  mounted() {
    this.getTableData();
  },
};
</script>
<style lang="scss" scoped>
.buttonlist {
  .buttonlist-m {
    padding: 10px 0 0 5px;
  }
}

.fenye {
  margin: 0;
  padding: 20px 0;
  background: #fff;
}

::v-deep .dangerbuttonxz .el-dialog {
  width: 800px !important;
}

.commonwidth {
  width: 650px;
  white-space: pre-wrap;
  word-break: break-all;
}
</style>